export default function FindReportCustomerDropDowns({
  formData,
  setFormData,
  handleInputChange,
}) {
  /*   All States
   ********************************************* */

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */

  return (
    <div className="col-6 flex-grow-1 px-3 py-2 my-1">
      {/* Material ID */}
      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor={"materialId"}>Material ID</label>
        </div>
        <div className="col-8">
          <input
            name={"materialId"}
            type={"text"}
            value={formData?.materialId || ""}
            onChange={(e) => {
              handleInputChange(e, "text");
            }}
            className="form-control form-control-sm w-100"
            placeholder={`🔎 Enter material ID`}
          />
        </div>
      </div>{" "}
      {/* Material Type */}
      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor={"type"}>Material Type</label>
        </div>
        <div className="col-8">
          <input
            name={"type"}
            type={"text"}
            value={formData?.type || ""}
            onChange={(e) => {
              handleInputChange(e, "text");
            }}
            className="form-control form-control-sm w-100"
            placeholder={`🔎 Enter material type`}
          />
        </div>
      </div>
      {/* Style ID */}
      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor={"styleId"}>Style ID</label>
        </div>
        <div className="col-8">
          <input
            name={"styleId"}
            type={"text"}
            value={formData?.styleId || ""}
            onChange={(e) => {
              handleInputChange(e, "text");
            }}
            className="form-control form-control-sm w-100"
            placeholder={`🔎 Enter style ID`}
          />
        </div>
      </div>
      {/* GSM */}
      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor={"gsm"}>GSM</label>
        </div>
        <div className="col-8">
          <input
            name={"gsm"}
            type={"text"}
            value={formData?.gsm || ""}
            onChange={(e) => {
              handleInputChange(e, "text");
            }}
            className="form-control form-control-sm w-100"
            placeholder={`🔎 Enter GSM`}
          />
        </div>
      </div>
      {/* Description */}
      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor={"description"}>Description</label>
        </div>
        <div className="col-8">
          <input
            name={"description"}
            type={"text"}
            value={formData?.description || ""}
            onChange={(e) => {
              handleInputChange(e, "text");
            }}
            className="form-control form-control-sm w-100"
            placeholder={`🔎 Enter description`}
          />
        </div>
      </div>
      {/* Minimum Quantity */}
      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor={"minQty"}>Min Quantity</label>
        </div>
        <div className="col-8">
          <input
            name={"minQty"}
            type={"text"}
            value={formData?.minQty || ""}
            onChange={(e) => {
              handleInputChange(e, "text");
            }}
            className="form-control form-control-sm w-100"
            placeholder={`🔎 Enter minimum quantity`}
          />
        </div>
      </div>
      {/* Color */}
      <div className="flex-grow-1 row mb-1">
        <div className="col-4 flex-center justify-content-start align-items-center">
          <label htmlFor={"color"}>Color</label>
        </div>
        <div className="col-8">
          <input
            name={"color"}
            type={"text"}
            value={formData?.color || ""}
            onChange={(e) => {
              handleInputChange(e, "text");
            }}
            className="form-control form-control-sm w-100"
            placeholder={`🔎 Enter color`}
          />
        </div>
      </div>
    </div>
  );
}
